import React, { useState } from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import dash1 from "../../../assets/Products/dash1.jpeg";
import dash2 from "../../../assets/Products/dash2.jpeg";
import dash3 from "../../../assets/Products/dash3.jpeg";
import dash4 from "../../../assets/Products/dash4.jpeg";

function DrishtiVdo() {
  const [activeSlide, setActiveSlide] = useState(0);

  const dashImages = [dash1, dash2, dash3, dash4];

 const settings = {
     dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,          // Enable automatic sliding
    autoplaySpeed: 1000,     // Time in ms (3 seconds per slide)
    pauseOnHover: true,      // Pause autoplay when user hovers

  };

  const videoUrls = [
    "https://www.youtube.com/watch?v=pUhVfoJdc-s",
    "https://www.youtube.com/watch?v=b7NKzbCZB6w",
    "https://www.youtube.com/watch?v=i-0KzRbGUzY",
    "https://www.youtube.com/watch?v=BjgI_8TTQjI",
    "https://www.youtube.com/watch?v=ur2Tei6SHyU",
  ];

  return (
    <>
      {/* Video Carousel */}
       <div className="w-full max-w-4xl mx-auto py-10">
      {/* Creative Heading */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-extrabold text-gray-800 tracking-tight">
          🎥 Innovation in Motion
        </h2>
        <p className="mt-2 text-lg text-gray-600">
          Explore our product stories through engaging videos
        </p>
      </div>

      {/* Slick Carousel */}
      <Slider {...settings}>
        <div>
          <div className="h-[500px] w-full">
            <iframe
              src="https://www.youtube.com/embed/pUhVfoJdc-s?si=0TL3p6mcMevJRK-l"
              title="YouTube video player"
              className="w-full h-full rounded-lg shadow-lg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div>
          <div className="h-[500px] w-full">
            <iframe
              src="https://www.youtube.com/embed/b7NKzbCZB6w?si=MHhEDUuf694Gl6U-"
              title="YouTube video player"
              className="w-full h-full rounded-lg shadow-lg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

         <div>
          <div className="h-[500px] w-full">
           <iframe width="560" height="315" src="https://www.youtube.com/embed/i-0KzRbGUzY?si=IV_cd7S8OciRkw5i" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>

         <div>
          <div className="h-[500px] w-full">
           <iframe width="560" height="315" src="https://www.youtube.com/embed/BjgI_8TTQjI?si=-m8ERkLprfMlXTFJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>

         <div>
          <div className="h-[500px] w-full">
           <iframe width="560" height="315" src="https://www.youtube.com/embed/ur2Tei6SHyU?si=QIsaBDmIBx1aXW1C" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>

         {/* <div>
          <div className="h-[500px] w-full">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/GeS3Eo3ZBpQ?si=grWTYcON8TumtoNT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div> */}

        {/* Repeat for other videos */}
      </Slider>
    </div>

      {/* Dashboard Carousel */}
      <div className="w-full max-w-4xl mx-auto py-10">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-extrabold text-gray-800 tracking-tight">
            Visualizing Your Data
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Turning Petroleum Data into Powerful Insights with Synergy Drishti Dashboard
          </p>
        </div>

        <Slider {...settings}>
          {dashImages.map((src, index) => (
            <div key={index} className="h-[500px] w-full">
              <img
                src={src}
                alt={`Dashboard ${index + 1}`}
                className="w-full h-full object-cover rounded-lg shadow-lg"
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default DrishtiVdo;